import Button from './button';
import ButtonGroup from './button-group';
Button.Group = ButtonGroup;
export default Button;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/button/index.js
// module id = 84
// module chunks = 0